export enum SignalRChannel {
    StatusLockPunches = 'StatusLockPunches',
    RefreshProcess = 'RefreshProcess',
    RefeshDownload = 'RefeshDownload',
    RefreshDocumentProcessor = 'RefreshDocumentProcessor',
    MaintenanceMode = 'MaintenanceModeActivated'
}

export interface SignalEvent<TDataShape> {
    type: SignalRChannel,
    data: TDataShape
}
